/* Scoped native commerce. All prices, availability and cart totals belong to Shopify. */
(() => {
  'use strict';
  const script = document.currentScript;
  const offerUrl = script && script.dataset.offerUrl;
  const root = (document.documentElement.dataset.lysvantaRoot || '/').replace(/\/$/, '');
  const cartUrl = `${root}/cart?view=lysvanta`;
  const jsonRequest = (url, body) => fetch(url, {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify(body)}).then(async response => {
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Handlingen kunne ikke gennemføres. Prøv igen.');
    return data;
  });
  document.addEventListener('DOMContentLoaded', () => {
    const localization = document.querySelector('[data-lysvanta-localization]');
    if (localization && (document.documentElement.dataset.country !== 'DK' || !document.documentElement.lang.startsWith('da'))) {
      localization.querySelector('[name="return_to"]').value = location.pathname + location.search + location.hash;
      localization.submit();
      return;
    }
    if (offerUrl) fetch(offerUrl, {credentials:'same-origin'}).then(r => r.json()).then(offer => {
      document.querySelectorAll('[data-offer-value]').forEach(element => {
        const value = offer[element.dataset.offerValue];
        if (typeof value === 'string' && value.trim()) element.textContent = value;
      });
    }).catch(() => {});
    document.querySelectorAll('[data-lysvanta-product-form]').forEach(form => {
      form.addEventListener('submit', async event => {
        event.preventDefault();
        const button = form.querySelector('[type="submit"]');
        const message = form.querySelector('[role="status"]');
        const id = Number(new FormData(form).get('id'));
        const quantity = Number(new FormData(form).get('quantity')) || 1;
        if (!id) { message.textContent = 'Vælg et tilgængeligt sæt først.'; return; }
        button.disabled = true;
        message.textContent = 'Lægger i kurven…';
        try {
          await jsonRequest(`${root}/cart/add.js`, {items:[{id,quantity}]});
          // Attribute failure must never cause a second add or hide a successful first add.
          try { await jsonRequest(`${root}/cart/update.js`, {attributes:{lysvanta:'1'}}); } catch (_) {}
          location.assign(cartUrl);
        } catch (error) {
          message.textContent = error.message;
          button.disabled = false;
        }
      });
    });
    document.querySelectorAll('[data-cart-quantity]').forEach(input => input.addEventListener('change', async () => {
      const row = input.closest('[data-cart-key]');
      const status = row.querySelector('[role="status"]');
      input.disabled = true;
      try {
        await jsonRequest(`${root}/cart/change.js`, {id:row.dataset.cartKey,quantity:Math.max(0,Number(input.value)||0)});
        location.assign(cartUrl);
      } catch (error) { status.textContent = error.message; input.disabled = false; }
    }));
    document.querySelectorAll('[data-cart-remove]').forEach(link => link.addEventListener('click', async event => {
      event.preventDefault();
      const row = link.closest('[data-cart-key]');
      try { await jsonRequest(`${root}/cart/change.js`, {id:row.dataset.cartKey,quantity:0}); location.assign(cartUrl); }
      catch (error) { row.querySelector('[role="status"]').textContent = error.message; }
    }));
    document.querySelectorAll('video').forEach(video => {
      video.setAttribute('playsinline','');
      if (!video.autoplay) video.setAttribute('controls','');
    });
    document.querySelectorAll('a[href="#lysvanta-buy"]').forEach(link => link.addEventListener('click', () => {
      document.getElementById('lysvanta-buy')?.scrollIntoView({behavior:'smooth',block:'start'});
    }));
  });
})();
